import { Component, OnInit, forwardRef, Output, Input, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { TypeaheadMatch } from 'ngx-bootstrap';

const noop = () => {};

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AppTagsInputComponent),
  multi: true,
};

@Component({
  selector: 'app-tags-input',
  templateUrl: './tags-input.component.html',
  styleUrls: ['./tags-input.component.css'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class AppTagsInputComponent implements OnInit, ControlValueAccessor {
  protected selected = '';
  public tags: any[] = [];
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  @Input() maxTags: number;
  @Input() removeLastOnBackspace = false;
  @Input() canDeleteTags = true;
  @Input() placeholder = '';
  @Input() options: any = null;
  @Input() displayField = 'displayValue';
  @Output() onTagsChanged = new EventEmitter();
  @Output() onMaxTagsReached = new EventEmitter();
  @Output() onNoOptionsMatch = new EventEmitter();

  ngOnInit() {
    console.log(this.tags, 'this.tags');
  }

  protected getPlaceHolder(): string {
    if (this.tags && this.tags.length > 0) {
      return '';
    }
    return this.placeholder;
  }

  private tagsChanged(type: string, tag: any): void {
    this.onChangeCallback(this.tags);
    this.onTagsChanged.emit({
      change: type,
      tag: tag,
    });
    if (this.maximumOfTagsReached()) {
      this.onMaxTagsReached.emit();
    }
  }

  protected removeLastTag(tagInput: HTMLInputElement): void {
    if (!this.removeLastOnBackspace || !this.tags.length) {
      return;
    }

    if (tagInput.value === '') {
      this.removeTag(this.tags[this.tags.length - 1]);
    }
  }

  protected addTag(tagInput: HTMLInputElement): void {
    if (tagInput.value.trim() !== '') {
      const tag = {
        [this.displayField]: tagInput.value,
      };
      this.addPredefinedTag(tag);
    }
    tagInput.value = '';
  }

  private addPredefinedTag(tag: Object): void {
    if (!this.maximumOfTagsReached()) {
      this.tags.push(tag);
      this.tagsChanged('add', tag);
    }
  }

  protected removeTag(tagToRemove: any): void {
    if (!this.isDeleteable(tagToRemove)) {
      return;
    }
    this.tags = this.tags.filter(tag => tagToRemove !== tag);
    this.tagsChanged('remove', tagToRemove);
  }

  protected maximumOfTagsReached(): boolean {
    return typeof this.maxTags !== 'undefined' && this.tags.length >= this.maxTags;
  }

  protected isDeleteable(tag: any) {
    if (typeof tag.deleteable !== 'undefined' && !tag.deleteable) {
      return false;
    }
    return this.canDeleteTags;
  }

  protected typeaheadOnSelect(e: TypeaheadMatch): void {
    if (typeof e.item === 'string') {
      this.addPredefinedTag({
        [this.displayField]: e.value,
      });
    } else {
      this.addPredefinedTag(e.item);
    }
    this.selected = '';
  }

  protected typeaheadOnNoMatch(e: any): void {
    if (typeof this.onNoOptionsMatch !== 'undefined') {
      this.onNoOptionsMatch.emit(e);
    }
  }

  writeValue(value: any) {
    if (value !== this.tags && value !== undefined && value !== null) {
      if (typeof value === 'string') {
        value = value.split(',');
      }
      this.tags = value;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/tags-input/tags-input.component.ts